import React from "react";

// Exact homepage-hero background treatment, shared by every light-blue section.
// Uses the SAME classes/layers as the hero: blue surface + geometric network
// artwork + hero blue gradient overlay, plus navy feathering into dark sections.
const ART = "https://static.prod-images.emergentagent.com/jobs/d8e47eb4-9ceb-4272-ba98-a0a7b79b0bb8/images/7d593bb6f9b893a27db19cf787d9d22772f333c1091e055ed75f00dcfd9eb81b.png";

export const TPAgencyBlueBackground = () => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true" data-testid="tp-blue-bg">
    <div className="absolute inset-0 hero-surface" />
    <img src={ART} alt="" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover opacity-30" />
    <div className="absolute inset-0 hero-overlay-r" />
    <div className="absolute inset-0 band-blue-feather" />
  </div>
);

export const Band = ({ tone = "dark", className = "", children }) => (
  <div className={`band band-${tone} relative ${className}`}>
    {tone === "light" && <TPAgencyBlueBackground />}
    <div className="relative">{children}</div>
  </div>
);
